export default __webpack_public_path__ + "static/media/doc-search.5082ec92.svg";